module.exports = __webpack_public_path__ + "img/attendance_0.0e674f4d.png";